import React from "react";
import "../css/property-card.css";

const currencyFormatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  maximumFractionDigits: 0,
});

const PropertyCard = ({ property, href }) => (
  <article className="property-card">
    <a
      className="property-card-image-link"
      href={href}
      aria-label={`Ver ${property.type} ${property.code} em ${property.city}`}
    >
      <img
        className="property-card-image"
        src={property.image}
        alt={`${property.type} em ${property.neighborhood}, ${property.city}`}
        loading="lazy"
      />
      <span className="property-card-badge">{property.badge}</span>
      <span className="property-card-code">{property.code}</span>
    </a>

    <div className="property-card-content">
      <p className="property-card-type">{property.type}</p>
      <h3 title={`${property.neighborhood} - ${property.city}`}>
        {property.neighborhood} - {property.city}
      </h3>
      <p className="property-card-condominium">{property.condominium}</p>
      <ul className="property-card-details" aria-label="Características">
        <li>{property.area} m²</li>
        {property.bedrooms > 0 && <li>{property.bedrooms} quartos</li>}
        <li>{property.bathrooms} banheiros</li>
        <li>{property.parkingSpaces} vagas</li>
      </ul>
      <div className="property-card-footer">
        <p className="property-card-price-label">A partir de</p>
        <p className="property-card-price">
          {currencyFormatter.format(property.price)}
        </p>
        <a className="property-card-button" href={href}>
          Ver detalhes
        </a>
      </div>
    </div>
  </article>
);

export default PropertyCard;
